'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ConsoleBrandingRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConsoleBrandingRemote = exports.ConsoleBrandingRemote = {
    fetchConsoleBranding: function fetchConsoleBranding(_ref) {
        var catalogId = _ref.catalogId,
            deployment = _ref.deployment,
            sellerId = _ref.sellerId;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({ deployment: deployment, path: '<ITEM-API>console/branding' });
            request.send({
                catalogId: catalogId,
                sellerId: sellerId
            });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/consoleBranding.js
// module id = H2WY
// module chunks = 60